import { apiSlice } from '../apiSlice';

export const unitedAssociatesAPI = apiSlice
  .enhanceEndpoints({ addTagTypes: ['ua'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getCorrectText: build.query({
        query: (data: any) => ({
          url: `/speech-advisor/v1/correct`,
          method: 'POST',
          data,
        }),
        providesTags: ['ua'],
      }),
      getSaveCorrectText: build.query({
        query: (data: any) => ({
          url: `/mgmt/tutor/learning-evaluation/ua/advisor/texts`,
          method: 'POST',
          data,
        }),
        providesTags: ['ua'],
      }),
      saveCorrectText: build.mutation({
        query: (data: any) => ({
          url: `/mgmt/tutor/learning-evaluation/advisor/texts`,
          method: 'POST',
          data,
        }),
        invalidatesTags: ['ua'],
      }),
    }),
  });

export const {
  useLazyGetCorrectTextQuery,
  useGetSaveCorrectTextQuery,
  useSaveCorrectTextMutation,
}: any = unitedAssociatesAPI;
